<template>
<div class="panel panel-clinic">

    <div class="panel-heading collapsed" href="#form_bonus" data-toggle="collapse">

        <div class="arrow-down"></div>

        <h2 class="panel-title">Ersättning, bonus och avdrag</h2>

    </div>

    <div id="form_bonus" class="panel-collapse collapse">

        <div class="panel-body">
            <div class="form-horizontal">

                <div class="list-group">

                    <div class="list-group-item log-head">
                        <div class="row">
                            <div class="col-md-10">
                                Period
                            </div>
                            <div class="col-md-10">
                                Kostnadskonto
                            </div>
                            <div class="col-md-10">
                                Belopp
                            </div>
                            <div class="col-md-10">
                                Specifikation
                            </div>
                        </div>
                    </div>

                    <div class="list-group-item log-item" v-for="bonus in bonusesFiltered">
                        <div class="row">
                            <div class="col-md-10">
                                {{bonus.date.substr(0, 7)}}
                            </div>
                            <div class="col-md-10">
                                {{bonus.account_name}}
                            </div>
                            <div class="col-md-10">
                                {{bonus.amount}} kr
                            </div>
                            <div class="col-md-16">
                                {{bonus.description}}
                            </div>
                            <div class="col-md-4">
                                <div class="btn btn-xs btn-danger" style="float:right;" @click="trash(bonus.id)" v-if="canDelete(bonus)">
                                    -
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="list-group-item log-add">
                        <div class="row">
                            <div class="col-md-10">
                                <month-picker :disabled-to="disabledTo" :value="newBonus.date" @changed="newBonus.date = arguments[0]"></month-picker>
                            </div>
                            <div class="col-md-10">
                                <select class="form-control" v-model="newBonus.account_id">
                                    <option value="3">4010</option>
                                    <option value="2">4011</option>
                                    <option value="1">4012</option>
                                    <option value="4">4013</option>
                                </select>
                            </div>
                            <div class="col-md-10">
                                <input type="text" class="form-control" placeholder="Summa i kronor" v-model="newBonus.amount" />
                            </div>
                            <div class="col-md-16">
                                <input type="text" class="form-control" placeholder="Specifikation" v-model="newBonus.description" />
                            </div>
                            <div class="col-md-4">
                                <div class="btn btn-default" style="float:right;" @click="store()">Lägg till</div>
                            </div>
                        </div>

                        <div class="alert alert-warning" style="margin-top: 30px;" role="alert" v-if="error">
                            Vänligen fyll i alla fält korrekt.
                        </div>

                    </div>

                </div>

            </div>
        </div>

    </div>

</div>
</template>

<script>

export default {

    props: {

        clinic: {
            required: true
        },

        payments: {
            required: true
        }

    },

    data () {
        return {

            bonuses: this.clinic.bonuses,

            newBonus: {
                account_id: 1,
                date: null,
                amount: '',
                description: ''
            },

            valid_from: null,
            disabledTo: moment(
                this.payments.lastAccountedYearAndMonth.year + '-' + this.payments.lastAccountedYearAndMonth.month + '-01'
            ).add(1, 'month').startOf('month'),

            submitted: false,
            error: false

        }
    },

    computed: {

        bonusesFiltered () {
            return this.bonuses
        }

    },

    methods: {

        resetNewBonus () {
            this.newBonus.amount = ''
            this.newBonus.description = ''
        },

        store () {
            if (this.submitted) {
                return
            }

            this.submitted = true

            this.$http.post('/clinics/' + this.clinic.id + '/bonus', this.newBonus).then((response) => {
                console.log(response.body)
                console.log('added bonus')

                this.submitted = false

                if (response.body.status === 'ok') {
                    this.error = false
                    this.bonuses = response.body.bonuses
                    this.resetNewBonus()

                    bus.$emit('notify', 'Bonus tillagd.')
                }
            }, (response) => {
                this.submitted = false
                this.error = true

                console.log(JSON.stringify(response))
            })
        },

        trash (bonus_id) {
            this.$http.delete('/clinics/' + this.clinic.id + '/bonus/' + bonus_id).then((response) => {
                console.log(response.body)
                console.log('removed bonus')

                if (response.body.status === 'ok') {
                    this.bonuses = response.body.bonuses

                    bus.$emit('notify', 'Bonus borttagen.')
                }
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        canDelete (bonus) {
            return moment(bonus.date).isAfter(moment(this.payments.lastAccountedYearAndMonth.year + '-' + this.payments.lastAccountedYearAndMonth.month + '-01'), 'month')
        }

    }
}
</script>
